<template>
  <AppView
    :show-bottom-bar="hasSelectedGoals && !isDisabled && isMentor"
    padd-bottom
  >
    <TopNav
      type="back"
      :show-notification-icon="!isMobileView"
      slot="top-app-view"
    >
      <BaseButton
        v-if="isMentor"
        slot="right-actions"
        class="tw-bg-gray-100 tw-mr-6 tw-align-middle tw-text-uppercase"
        :text="btnText"
        :disabled="!hasSelectedGoals || isDisabled"
        @click="saveSettings()"
      />
    </TopNav>

    <div class="mx-body">
      <template v-if="isMentor">
        <h3 class="tw-text-center opacity-87 tw-text-xl tw-mt-6 font-title">
          My Areas of Expertise
        </h3>
        <h5 class="tw-text-center opacity-54 tw-text-sm leading-17 tw-mt-2">
          Choose areas where you could help a mentee.
          <br>
          This will help us in matching you with the right mentee.
        </h5>
      </template>
      <template v-else-if="isMentee">
        <h3 class="tw-text-center opacity-87 tw-text-xl tw-mt-6 font-title">
          My Goals
        </h3>
        <!-- <h5 class="tw-text-center opacity-54 tw-text-sm leading-17 tw-mt-2">
          Choose goals you'd like to achieve with the help of mentors.
          <br>
          We will match you with the right mentor(s) in the specified goals.
        </h5> -->
      </template>

      <!-- <div class="tw-flex tw-mt-4 tw-items-center tw-relative">
        <h6 class="tw-text-xs">Selected {{ totalSelectedGoals() }} of  maximum {{ totalGoalsCanSelect }}</h6>
      </div> -->

      <div class="divider tw-border tw-w-full tw-mt-16 opacity-11"></div>
      <transition mode="out-in" name="fade" appear>
        <GoalsSettingsMentor
          v-if="isMentor"
          ref="goal-settings"
          @view-mounted="updatedCounts += 1"
        />
        <GoalsSettingsMenteeGoals
          v-else-if="isMentee"
          ref="goal-settings"
          @view-mounted="updatedCounts += 1"
        />
      </transition>
    </div>

    <div
      slot="bottom-app-view"
      class="px-body tw-py-4"
    >
      <BaseButton
        class="tw-bg-app-deep-blue tw-py-4 tw-mt-4 tw-max-w-md tw-mx-auto tw-text-white tw-block tw-border-0 tw-w-full tw-shadow-xl opacity-54 hover:tw-opacity-100 transition-fast"
        text="SAVE"
        :disabled="!hasSelectedGoals || isDisabled"
        @click="saveSettings()"
      />
    </div>
  </AppView>
</template>

<script>
import { mapState } from 'vuex';
// import SearchInput from '@/components/SearchInput.vue';
import GoalsSettingsMentor from '@/views/_partials/GoalsSettings/MentorGoalsSettings.vue';
import GoalsSettingsMenteeGoals from '@/views/_partials/GoalsSettings/Mentee/Goals.vue';

export default {
  components: {
    // SearchInput,
    GoalsSettingsMentor,
    GoalsSettingsMenteeGoals,
  },
  data() {
    return {
      loading: true,
      isDisabled: false,
      btnDataName: 'saveButtonText',
      btnText: 'Save',
      updatedCounts: 0,
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    // goals: _debounce(function () {
    //   this.sortGoalGroups();
    // }, 500),
  },
  computed: {
    ...mapState({
      mentorGoals: state => state.User.mentor.goals,
    }),
    totalGoalsCanSelect() {
      // eslint-disable-next-line no-unused-expressions
      this.updatedCounts;
      if (this.$refs['goal-settings']) {
        return this.$refs['goal-settings'].totalGoalsCanSelect;
      }
      return 0;
    },
    hasSelectedGoals() {
      // eslint-disable-next-line no-unused-expressions
      this.updatedCounts;
      if (this.$refs['goal-settings']) {
        return this.$refs['goal-settings'].hasSelectedGoals;
      }
      return false;
    },
  },
  methods: {
    totalSelectedGoals() {
      // eslint-disable-next-line no-unused-expressions
      this.updatedCounts;
      if (this.$refs['goal-settings']) {
        return this.$refs['goal-settings'].totalSelectedGoals();
      }
      return 0;
    },
    async saveSettings() {
      // eslint-disable-next-line no-unused-expressions
      this.updatedCounts;
      if (!this.$refs['goal-settings']) {
        this.$toasted.global.appError();
        return false;
      }
      this.btnText = 'Saving...';
      this.isDisabled = true;
      await this.$refs['goal-settings'].saveSettings();
      this.isDisabled = false;
      this.btnText = 'Save';
      return true;
    },
  },
  async mounted() {
    this.$store.commit('isFlatView', false);
    this.updatedCounts += 1;
  },
};
</script>

<style>

</style>
